import { CardContainer } from "@letsbit/milkylb";
import dayjs from "dayjs";
import { useFormatter } from "hooks/utils/useFormatter";
import { BymaActivitiesScrollCouponProps } from "./types";
import { MERK_ACTIVITY_FILTER_BY_DATE } from "@letsbit/malcolmlb";

export const BymaActivitiesScrollCoupon: React.FC<
  BymaActivitiesScrollCouponProps
> = ({ activity, onClick, byDate }) => {
  const { formatValue } = useFormatter();
  return (
    <CardContainer
      className="mb-2 cursor-pointer"
      onClick={() => onClick?.(activity)}
    >
      <div className="grid grid-cols-5 p-4">
        <div className="flex h-full items-center">
          <p className="truncate text-lg font-bold text-[--milkylb-color-neutral-600]">
            {activity.data.operation_type}
          </p>
        </div>
        <div className="flex h-full items-center">
          <p className="truncate text-lg font-bold text-[--milkylb-color-neutral-600]">
            {dayjs(
              byDate === MERK_ACTIVITY_FILTER_BY_DATE.LIQUIDATION
                ? activity.data.settlement_date
                : activity.data.agreement_date,
            ).format("DD.MM.YYYY")}
          </p>
        </div>
        <div className="flex h-full items-center">
          <p className="truncate text-lg font-bold text-[--milkylb-color-neutral-600]">
            {formatValue(activity.data.quantity.toString())}
          </p>
        </div>
        <div className="flex h-full items-center">
          <p className="truncate text-lg font-bold text-[--milkylb-color-neutral-600]">
            $ {formatValue(activity.data.price.toString())}{" "}
            {activity.data.currency_iso.toUpperCase()}
          </p>
        </div>
        <div className="flex h-full items-center">
          <p className="truncate text-lg font-bold text-[--milkylb-color-neutral-600]">
            $ {formatValue(activity.data.net.toString())}{" "}
            {activity.data.currency_iso.toUpperCase()}
          </p>
        </div>
      </div>
    </CardContainer>
  );
};
